/**
 * EntitiesSidebarNavigationItem
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EntityTypeName from '../../../../../../components/EntityTypeName';
import SidebarSubnavigationLink from '../SidebarSubnavigationLink';

// Selectors
import { makeSelectIds } from './selectors';

interface Props {
    ids?: List<number>;
    onClick: Function;
}

export class EntitiesSidebarNavigationItem extends React.Component<Props> {
    render() {
        const { ids, onClick } = this.props;
        if (!ids) return null;

        return (
            <React.Fragment>
                {ids.map(id => (
                    <SidebarSubnavigationLink
                        key={id}
                        pathname={`/organization/areas/${id}`}
                        title={<EntityTypeName entityTypeId={id} plural />}
                        onClick={onClick}
                    />
                ))}
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    ids: makeSelectIds()
});

export default connect(mapStateToProps)(EntitiesSidebarNavigationItem);
